import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo_image from '../assets/logo_image.png';
import loading_spinner from '../assets/loading_spinner.gif';
import { supabase } from '../supabase';
import { Form } from 'react-bootstrap';
import { FormControlLabel, Checkbox } from '@mui/material';

export default function Login() {
  const baseURL = "http://localhost:3000"
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [seePasswords, setSeePasswords] = useState(false);
  const [createAccount, setCreateAccount] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  // error messages
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [confirmPasswordErrorMsg, setConfirmPasswordErrorMsg] = useState("");

  // get local storage
  let initSession = localStorage.getItem("sb-wtlkhsfpanurgzhaiocq-auth-token");
  if (initSession) {
    initSession = JSON.parse(initSession);
  }
  
  const notifyErrorMsg = (errorMsg) => toast.error(<p>{errorMsg}</p>, {
    toastId: 'signupError',
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  });

  const handleEmail = () => {
    if (/(.+)@(.+){2,}\.(.+){2,}/.test(email) || email === '' || createAccount === false) {
        setEmailErrorMsg('');
        return true;
    }
    // setEmailErrorMsg('');
    setEmailErrorMsg('Email is invalid.');
    return false;
  }

  const handlePassword = () => {
    if (password.length > 5 || password === '' || createAccount === false) {
      setPasswordErrorMsg('');
      return true;
    }
    setPasswordErrorMsg('Password must be 6 characters or longer.');
    return false;
  }

  const handleConfirmPassword = () => {
    if (password === confirmPassword || createAccount === false) {
      setConfirmPasswordErrorMsg('');
      return true;
    }
    setConfirmPasswordErrorMsg('Passwords do not match.');
    return false;
  }

  const handleSignUpBtn = () => {
    if (
      (/(.+)@(.+){2,}\.(.+){2,}/.test(email)) &&
      (password.length > 5) &&
      (password === confirmPassword)
    ) {
      return false; // don't disable button
    }
    return true; // disable button
  }

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (createAccount) {
      // sign up
      try {
        const { error } = await supabase.auth.signUp({
          email: email,
          password: password,
        })
        if (error === null) {
          let newURL = null
          if (window.location.href.includes("localhost:3000")) {
              newURL = `http://localhost:3000/login`;
          } else {
              newURL = `http://eggshelliq.com/login`;
          }
          window.history.pushState('page2', 'Title', newURL);
          setTimeout(function() { setLoading(false) }, 500);
          setTimeout(function() { setVerifyEmail(true) }, 500);
        }
        if (error) throw error
      } catch (error) {
        notifyErrorMsg(error.error_description || error.message);
        setLoading(false);
      }
    } else {
      // sign in
      try {
        const { error } = await supabase.auth.signInWithPassword({
          email: email,
          password: password,
        })
  
        if (error) {
          throw error
        } else {
          let currentURL = window.location.href;
          if (initSession) {
            if (currentURL === `${baseURL}/login`) {
              window.location.href = `${baseURL}/dashboard`;
            }
          } else {
            if (currentURL.includes("dashboard")) {
              window.location.href = baseURL;
            }
          }
          window.location.reload(true);
        }
      } catch (error) {
        notifyErrorMsg(error.error_description || error.message);
        setLoading(false);
      }
    }
  }

  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);
  const isMobile = width <= 768;

  return (
    <div className='flex justify-center items-center text-center text-xl -mt-12' style={{height: '95vh'}}>
        {verifyEmail ? (
          <div style={{width: isMobile ? '350px' : '400px'}}>
            <div className='flex justify-center mb-4'>
              <img src={logo_image} alt="logo" className="h-28" />
            </div>
            <p className='lg:text-4xl text-3xl text-dark-gray font-extrabold mb-3 tracking-tighter'>Confirm your email 📨</p>
            <div className='text-lg flex justify-start items-center text-start gap-4 bg-light-gray rounded-xl p-3 mt-12'>
              <p className='pl-4 text-2xl'>✅</p>
              <p>A confirmation email was just sent to {email}.</p>
            </div>
            <div className='text-lg flex justify-start items-center text-start gap-4 bg-light-gray rounded-xl p-3 mt-4'>
              <p className='pl-4 text-2xl'>📂</p>
              <p>Check your spam if you cannot find the email.</p>
            </div>
            <div className='text-lg flex justify-start items-center text-start gap-4 bg-light-gray rounded-xl p-3 mt-4'>
              <p className='pl-4 text-2xl'>➡️</p>
              <p>Sign in after confirming your email.</p>
            </div>
          </div>
        ) : (
          <div className='w-96'>
            <div className='flex justify-center mb-4'>
              <img src={logo_image} alt="logo" className="h-28" />
            </div>
            {createAccount ? (
              <p className='lg:text-4xl text-2xl text-dark-gray font-extrabold mb-3 tracking-tighter'>Create an account</p>
            ) : (
              <p className='lg:text-4xl text-2xl text-dark-gray font-extrabold mb-3 tracking-tighter'>Login to <span className='text-eggshell-green'>Eggshell</span></p>
            )}
            <div className='flex justify-center mt-4'>
              <p className='text-lg w-80'>{createAccount ? 'Sign up' : 'Login'} to order, access, and analyze your market reports.</p>
            </div>
            <div className='flex justify-center mt-4'>
              <Form className='text-base'>
                <Form.Group id="email">
                  <Form.Control
                    required
                    style={{borderWidth: '1px'}}
                    className='h-12 border-gray rounded-md w-80 pl-3'
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={handleEmail}
                  />
                </Form.Group>
                <div className={(emailErrorMsg === '') ? 'hidden' : 'flex justify-left -mt-3 mb-2'}>
                  <p className='text-red ml-2 text-left'>{emailErrorMsg}</p>
                </div>
                <Form.Group id="password" className='flex justify-center'>
                  <Form.Control
                      required
                      style={{borderWidth: '1px'}}
                      className='h-12 border-gray rounded-md w-80 pl-3 -mt-1'
                      id="password"
                      type={(seePasswords ? 'text': 'password')}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onBlur={handlePassword}
                  />
                </Form.Group>
                <div className={(passwordErrorMsg === '') ? 'hidden' : 'flex justify-left -mt-3 mb-2'}>
                  <p className='text-red ml-2 text-left'>{passwordErrorMsg}</p>
                </div>
                <Form.Group id="confirmPassword" className={`${createAccount ? 'flex justify-center' : 'hidden'}`}>
                  <Form.Control
                    required
                    style={{borderWidth: '1px'}}
                    className='h-12 border-gray rounded-md w-80 pl-3 -mt-1'
                    id="confirmPassword"
                    type={(seePasswords ? 'text': 'password')}
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={handleConfirmPassword}
                  />
                </Form.Group>
                <div className={(confirmPasswordErrorMsg === '') ? 'hidden' : 'flex justify-left -mt-3 mb-2'}>
                  <p className='text-red ml-2 text-left'>{confirmPasswordErrorMsg}</p>
                </div>
                <div className='flex justify-start ml-2 mt-2 mb-1'>
                  <FormControlLabel
                    control={
                        <Checkbox
                          checked={seePasswords}
                          sx={{
                            color: 'dark-gray',
                            '&.Mui-checked': {
                              color: '#64B298',
                            },
                          }}
                        />
                    }
                    label="See passwords"
                    onClick={() => setSeePasswords(!seePasswords)}
                  />
                </div>
                <div className='flex justify-center'>
                    {createAccount ? (
                      <button
                        size="lg"
                        disabled={handleSignUpBtn()}
                        onClick={(e) => handleSignUp(e)}
                        className={`mt-1 text-white w-full py-2.5 rounded-xl text-xl ${handleSignUpBtn() ? 'bg-light-eggshell-green' : 'bg-eggshell-green'}`}
                      >
                        {loading ? (
                          <div className='flex justify-center items-center'>
                            <img src={loading_spinner} className='h-8 text-center text-white' alt='Loading...' />
                          </div>
                        ) : (
                          'Create account'
                        )}
                      </button>
                    ) : (
                      <button
                        size="lg"
                        onClick={(e) => handleSignUp(e)}
                        className={`mt-1 text-white w-full py-2.5 rounded-xl text-xl bg-eggshell-green`}
                      >
                        {loading ? (
                          <div className='flex justify-center items-center'>
                            <img src={loading_spinner} className='h-8 text-center text-white' alt='Loading...' />
                          </div>
                        ) : (
                          'Login'
                        )}
                      </button>
                    )}
                </div>
              </Form>
            </div>
            <div className='flex justify-center text-base mt-3'>
              <p className='p-2 pr-1'>
                {createAccount ? 'Already have an account?' : 'No account?'}
              </p>
              <p style={{ marginTop: '3px', paddingTop: '5px' }} className='text-eggshell-green font-semibold cursor-pointer px-2 rounded-xl hover:bg-xlight-eggshell-green' onClick={() => setCreateAccount(!createAccount)}>
                {createAccount ? 'Sign in' : 'Create account'}
              </p>
            </div>
          </div>
        )}
    </div>
  )
}
